export default "__VITE_ASSET__BHSVGxYG__"